const CompanyLogo = ({ className = 'w-8 h-8' }) => (
  <svg
    className={className}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 293 135"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill="#FFFFFF"
        d="M144,29.4v3c1.5,0.2,2.8,0.3,3.8,0.6c1.2,0.3,2.1,0.7,2.8,1.2c1.9,1.6,1.9,4.7,1.9,10.3l0,37.4
      c0,7.6,0.7,18.4-10.1,18.2c-4.6-0.1-9.4-3.4-10.8-9.4h-3.7c1.6,10.1,6.9,16.9,19.9,16.9h0h0c11,0,20.9-5.1,20.9-22.3V56.2V44.4
      c0-5.6,0-8.5,1.9-10.2c1.2-1.1,2.2-1.6,5.6-1.9v-3h-24.5H144z"
      />
      <path
        fill="#FFFFFF"
        d="M231,90.7c-3.7,8.2-9.5,9.2-14.8,9.2c-4.3,0-7.2-0.2-9.2-1.6c-1.6-1.1-2.3-3.8-2.3-8.5V45.3v-0.8
      c0-5.6,0-8.6,1.9-10.3c1.2-1.1,3.3-1.4,6.6-1.8v-3v0h-32.2v0v2.8v0.1c3.4,0.3,4.4,0.8,5.6,1.9c1.5,1.3,1.8,3.5,1.9,7.1
      c0,1.1,0,2.4,0,3.7v44.7c0,1.4,0,2.6,0,3.7c-0.1,3.7-0.3,5.8-1.9,7.1c-1.2,1.1-2.2,1.6-5.6,1.9v0.1v2.8v0h32.2v0h0.1h16.3l5.1-14.9
      H231z"
      />
      <path
        fill="#FFFFFF"
        d="M284.7,90.7c-3.7,8.2-9.5,9.2-14.8,9.2c-4.3,0-7.2-0.2-9.2-1.6c-1.6-1.1-2.3-3.8-2.3-8.5V45.3v-0.8
      c0-5.6,0-8.6,1.9-10.3c1.2-1.1,3.3-1.4,6.6-1.8v-3v0h-32.2v0v2.8v0.1c3.4,0.3,4.4,0.8,5.6,1.9c1.5,1.3,1.8,3.5,1.9,7.1
      c0,1.1,0,2.4,0,3.7v44.7c0,1.4,0,2.6,0,3.7c-0.1,3.7-0.3,5.8-1.9,7.1c-1.2,1.1-2.2,1.6-5.6,1.9v0.1v2.8v0h32.2v0h0.1h16.3l5.1-14.9
      H284.7z"
      />
      <path
        fill="#FFFFFF"
        d="M108.8,26.2c-3.2-6.4-7.6-12.4-13.3-16.7C91.2,6.3,85.9,4.1,80.5,4h0l0,0h0c-3.4,0.1-6.8,1-9.9,2.4
      c-2.1-0.9-4.2-1.6-6.4-2c-0.5-0.1-1.1-0.2-1.6-0.2l0,0C61.9,4.1,61.3,4,60.7,4h0h0h0c-3.4,0.1-6.8,1-9.9,2.4
      C47.6,5,44.2,4.1,40.8,4h0l0,0h0c-5.4,0.1-10.8,2.3-15.1,5.5C20,13.8,15.7,19.8,12.5,26.2C8.5,33.9,6,42.6,4.7,51
      c-0.8,5.5-1.2,11-1.2,16.5h0c0,5.4,0.4,11,1.2,16.5c1.3,8.5,3.8,17.1,7.8,24.9c3.2,6.4,7.6,12.4,13.3,16.7
      c4.3,3.2,9.7,5.3,15.1,5.5h0h0h0c3.4-0.1,6.8-1,9.9-2.4c0,0,0,0,0,0c0,0,0,0,0,0c2.1,0.9,4.2,1.6,6.4,2c0.5,0.1,1.1,0.2,1.6,0.2
      c0,0,0,0,0,0c0,0,0,0,0,0c0.6,0.1,1.2,0.1,1.9,0.1h0v0h0c3.4-0.1,6.8-1,9.9-2.4c0,0,0,0,0,0c0,0,0,0,0,0c3.1,1.4,6.5,2.3,9.9,2.4h0
      v0h0c5.4-0.1,10.8-2.3,15.1-5.5c5.8-4.3,10.1-10.3,13.3-16.7c4-7.8,6.5-16.4,7.8-24.9c0.8-5.5,1.2-11,1.2-16.5h0
      c0-5.4-0.4-11-1.2-16.5C115.3,42.6,112.8,33.9,108.8,26.2z M106.8,75.7c-1,14.5-4.9,29.1-13.1,41.2c-3.5,5.2-8,10.3-13.2,13.9
      c-2-1.4-3.9-3-5.6-4.7c0,0,0,0,0,0c0,0,0,0,0,0c0.3-0.2,0.6-0.4,0.9-0.6c5.7-4.3,10.1-10.3,13.3-16.7c4-7.8,6.5-16.4,7.8-24.9
      c0.8-5.5,1.2-11,1.2-16.5h0c0-5.4-0.4-11-1.2-16.5C95.5,42.6,93,33.9,89,26.2c-3-5.9-6.9-11.5-12-15.7c-1.6,1.8-3.2,3.6-4.6,5.5
      c0.5,0.7,1,1.4,1.4,2C82,30.2,85.9,44.8,86.9,59.3c0.2,2.7,0.3,5.5,0.3,8.2c0,2.7-0.1,5.5-0.3,8.2c-1,14.5-4.9,29.1-13.1,41.2
      c-1,1.5-2.1,3-3.3,4.5c-1.3,1.7-2.8,3.3-4.3,4.8c-1.6,1.6-3.4,3.1-5.2,4.4c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1-0.1-0.2-0.1-0.3-0.2
      c-0.5-0.4-1.1-0.8-1.6-1.2c-1.3-1-2.6-2.1-3.7-3.3c0,0,0,0,0,0c0,0,0,0,0,0c0.3-0.2,0.6-0.4,0.9-0.6c1.7-1.3,3.3-2.7,4.8-4.3
      c0,0,0,0,0,0c0,0,0,0,0,0c1.1,1.2,2.2,2.2,3.5,3.3c1.6-1.8,3.2-3.6,4.6-5.5c-0.5-0.7-1-1.4-1.4-2c-0.5-0.7-0.9-1.5-1.4-2.3
      c0,0,0,0,0,0c0,0,0,0,0,0c1.2-1.9,2.4-3.8,3.4-5.8c4-7.8,6.5-16.4,7.8-24.9c0.8-5.5,1.2-11,1.2-16.5h0c0-5.4-0.4-11-1.2-16.5
      c-1.3-8.5-3.8-17.1-7.8-24.9c-0.5-0.9-0.9-1.8-1.4-2.7c-2.1,3.9-3.8,7.9-5.2,12.1c2.6,7.6,4.1,15.7,4.6,23.7
      c0.2,2.7,0.3,5.5,0.3,8.2h0c0,2.7-0.1,5.5-0.3,8.2c-0.7,9.8-2.7,19.6-6.5,28.7c-1.5,3.5-3.2,6.9-5.2,10.2c-0.5,0.8-0.9,1.6-1.4,2.3
      c-1,1.5-2.1,3-3.3,4.5c-1.3,1.7-2.8,3.3-4.3,4.8c-1.6,1.6-3.4,3.1-5.2,4.4c-0.1,0.1-0.3,0.2-0.4,0.3c-5.2-3.7-9.7-8.7-13.2-13.9
      c-8.2-12.2-12.1-26.7-13.1-41.2c-0.2-2.7-0.3-5.5-0.3-8.2c0-2.7,0.1-5.5,0.3-8.2c1-14.5,4.9-29.1,13.1-41.2
      c3.5-5.2,8-10.2,13.2-13.9c2,1.4,3.9,3,5.6,4.7h0c-0.3,0.2-0.6,0.4-0.9,0.6c-5.7,4.3-10.1,10.3-13.3,16.7c-4,7.8-6.5,16.4-7.8,24.9
      c-0.8,5.5-1.2,11-1.2,16.5h0c0,5.4,0.4,11,1.2,16.5c1.3,8.5,3.8,17.1,7.8,24.9c3,5.9,6.9,11.5,12,15.7c1.6-1.8,3.2-3.6,4.6-5.5
      c-0.5-0.7-1-1.4-1.4-2c-8.2-12.2-12.1-26.7-13.1-41.2c-0.2-2.7-0.3-5.5-0.3-8.2c0-2.7,0.1-5.5,0.3-8.2c1-14.5,4.9-29.1,13.1-41.2
      c1-1.5,2.1-3,3.3-4.5c1.3-1.7,2.8-3.3,4.3-4.8c1.6-1.6,3.4-3.1,5.2-4.4c0.1-0.1,0.3-0.2,0.4-0.3c0.1,0.1,0.2,0.1,0.3,0.2h0
      c0.5,0.4,1.1,0.8,1.6,1.2c1.3,1,2.6,2.1,3.7,3.3c-0.3,0.2-0.6,0.4-0.9,0.6c-1.7,1.3-3.3,2.7-4.8,4.3c-1.1-1.2-2.2-2.2-3.5-3.3
      c-1.6,1.8-3.2,3.6-4.6,5.5c0.5,0.7,1,1.4,1.4,2c0.5,0.7,0.9,1.5,1.4,2.3v0c-1.2,1.9-2.4,3.8-3.4,5.8c-4,7.8-6.5,16.4-7.8,24.9
      c-0.8,5.5-1.2,11-1.2,16.5h0c0,5.4,0.4,11,1.2,16.5c1.3,8.5,3.8,17.1,7.8,24.9c0.5,0.9,0.9,1.8,1.4,2.7c2.1-3.9,3.8-7.9,5.2-12.1
      c-2.6-7.6-4.1-15.7-4.6-23.7c-0.2-2.7-0.3-5.5-0.3-8.2h0c0-2.7,0.1-5.5,0.3-8.2c0.7-9.8,2.7-19.6,6.5-28.7c1.5-3.5,3.2-7,5.2-10.2
      c0.5-0.8,0.9-1.6,1.4-2.3c1-1.5,2.1-3,3.3-4.5c1.3-1.7,2.8-3.3,4.3-4.8c1.6-1.6,3.4-3.1,5.2-4.4c0.1-0.1,0.3-0.2,0.4-0.3
      c5.2,3.7,9.7,8.7,13.2,13.9c8.2,12.2,12.1,26.7,13.1,41.2c0.2,2.7,0.3,5.5,0.3,8.2C107,70.2,106.9,73,106.8,75.7z"
      />
    </g>
  </svg>
);

export default CompanyLogo;
